"use client";

import { z } from "zod";

export const RecoverPwdSchema = z.object({
  emailCode: z
    .string()
    .length(8, "O código deve ter 8 dígitos.")
    .regex(/^\d+$/, "O código deve conter apenas números."),
});

export type RecoverPwdType = z.infer<typeof RecoverPwdSchema>;
